import * as React from 'react';
import FormSection from 'Components/FormSection';
import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import { useIntl } from 'react-intl';

const PlasmaChangeForm = ({ formData, editing }: IOwnProps): React.JSX.Element => {
  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });
  React.useEffect(() => {
    if (!formData.document?.code) {
      formData.onChange?.({
        code: { codeSystem: 'http://snomed.info/sct', code: '19647005', display: fm('procedure.plasmaChange') },
      });
    }
  }, []);

  return (
    <>
      <FormSection>
        <FormRow title="general.date">
          <InputHandler editing={!!editing} name="date" type="PartialDate" formData={formData} dateDefault="now" />
        </FormRow>
        <FormRow title="procedure.additionalInformation">
          <InputHandler
            editing={!!editing}
            name="additionalInformation"
            type="TextArea"
            formData={formData}
            placeholder={'procedure.additionalInformation'}
            width={35}
          />
        </FormRow>
      </FormSection>
    </>
  );
};

interface IOwnProps {
  formData: IFormData<IProcedure>;
  editing: string;
}

export default PlasmaChangeForm;
